/* Purpose: associate each real publication logo with its saved quote.
 * Usage: mvk-press custom element; each instance owns only its descendants.
 * Native buttons provide keyboard activation. No autoplay, network calls or
 * global carousel hooks. Connection/disconnection supports Theme Editor reloads. */
if (!customElements.get('mvk-press')) {
  customElements.define('mvk-press', class extends HTMLElement {
    connectedCallback() {
      // Format the server-rendered live Judge.me count for the active locale.
      this.querySelectorAll('[data-mvk-review-count]').forEach(count => {
        const value = Number(count.textContent.trim().replace(/,/g, ''));
        if (Number.isFinite(value)) count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(value);
      });
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.buttons = [...this.querySelectorAll('[data-mvk-press-button]')];
      this.quotes = [...this.querySelectorAll('[data-mvk-press-quote]')];
      this.buttons.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => this.select(button.dataset.blockId), options);
      });
      // Selecting a block in the editor should reveal that publication's quote.
      this.addEventListener('shopify:block:select', event => {
        this.select(event.detail?.blockId);
      }, options);
      this.select(this.buttons[0]?.dataset.blockId);
      this.setAttribute('data-ready', '');
    }
    select(id) {
      if (!this.buttons.some(button => button.dataset.blockId === id)) return;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.blockId === id)));
      this.quotes.forEach(quote => { quote.hidden = quote.dataset.blockId !== id; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
